import { render, staticRenderFns } from "./SpeechSkeleton.vue?vue&type=template&id=6883b5a4&scoped=true"
import script from "./SpeechSkeleton.vue?vue&type=script&lang=js"
export * from "./SpeechSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883b5a4",
  null
  
)

export default component.exports